import { BusinessErrorCode } from '@pulsify/shared/errors'
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { requestCreditTopUp } from '~/entities/credits/model/credit-top-up'
import { extractApiError } from '~/shared/lib/api-errors'

export function getContext() {
  const queryClient = new QueryClient({
    mutationCache: new MutationCache({
      onError: (error) => {
        if (extractApiError(error).errorCode === BusinessErrorCode.InsufficientCredits) {
          requestCreditTopUp()
        }
      },
    }),
  })
  return {
    queryClient,
  }
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode
  queryClient: QueryClient
}) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
